import { useState } from 'react';
import { categoryMap } from '../../../constants/dating';
import { useRouteContext, useSearchContext } from '../../../context';
import { categoryMapProps, DateOption } from '../interface';

export const useSingleToggle = ({
    categories,
    dateSelection,
}: {
    categories: Array<categoryMapProps>;
    dateSelection: DateOption;
}) => {
    const { location, parsedValues, history } = useRouteContext();
    const { setQuery } = useSearchContext();
    const urlCategory = categories.find(
        (category) => category.searchParam === parsedValues?.category,
    );
    const [selectedCategory, setToggled] = useState<categoryMapProps>(
        urlCategory ?? categories[0],
    );

    const updateRoute = (params: URLSearchParams) => {
        const pathname = location?.pathname;
        const path = `${pathname}?${params.toString()}`;
        history?.push(path);
    };

    const handleToggled = (idx: number) => {
        // Default to select the 'All' chip when unselecting a chip
        if (categories[idx] === selectedCategory) {
            idx = 0;
        }

        const searchParams = new URLSearchParams(location?.search);

        if (idx === 0) {
            searchParams.delete('category');
        } else {
            searchParams.set('category', categories[idx].searchParam);
        }

        const selectedTag = categoryMap[idx ?? 0];
        const query: any = {
            tags: selectedTag?.tags,
            q: selectedTag?.q,
            dates: [
                ...new Set([
                    dateSelection.searchValue,
                    ...(selectedTag?.dates || []),
                ]),
            ],
        };
        if (query && setQuery) {
            setQuery(query);
        }
        updateRoute(searchParams);

        setToggled(() => categories[idx]);
    };

    return { handleToggled, selectedCategory };
};
